module.exports = __webpack_public_path__ + "static/media/Camera22.7d3a6201.jpg";